import React, {useEffect} from 'react';
import {Platform} from 'react-native';
import {useAppDispatch} from '../../redux';
import {confirmContactsChange} from '../../redux/actions/profile';
import {addNotification} from '../../redux/actions/snackbar';
import {navigateToProfileUserContacts} from '../routing/profileEmailConfirmationNav';
import {SnackbarNotificationType} from '../components/snackbar/model';

export const useConfirmEmail = (
  isEmailConfirmationNeeded: boolean,
  code: string,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    (async () => {
      if (!isEmailConfirmationNeeded) return;

      try {
        if (Platform.OS === 'web') {
          const {origin, pathname} = window.location;
          window.history.replaceState(null, '', `${origin}${pathname}`);
        }
        await dispatch(confirmContactsChange(code));
        dispatch(
          addNotification({
            message: 'Новая эл. почта успешно сохранена.',
            type: SnackbarNotificationType.Success,
          }),
        );
      } catch (err: any) {
        dispatch(
          addNotification({
            message: err.data?.[0]?.message || err.message || 'Ссылка недействительна',
            type: SnackbarNotificationType.Error,
          }),
        );
      } finally {
        navigateToProfileUserContacts();
        setIsLoading(false);
      }
    })();
  }, [isEmailConfirmationNeeded, code, dispatch, setIsLoading]);
};
